// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld-base';
import pageHtml from 'text!html/phone/phoneLayoutDetails.html';
import 'myWorld/base/view';

myw.PhoneLayoutDetails = myw.Control.extend({
    innerTemplate: _.template(pageHtml),

    events: {
        'click .button-back': 'hide'
    },
    /**
     * @class A page to be used in the phone layout to display the object's detail, or a list of objects
     *        It has a page header with a title in the center and a left aligned back button
     * @param  {PhoneLayout}  owner     The owner of self.
     * @param  {viewOptions}      options
     * @extends {Control}
     * @constructs
     */
    //ENH: Find a better name for this class
    initialize(owner, options) {
        this.owner = owner;
        this.app = owner.app;
        myw.Control.prototype.initialize.call(this, owner, options);
        this.setElement(this.innerTemplate());
        if (this.attributes) this.$el.attr(this.attributes);
    },

    render() {
        this.$el.show();
        this.populateTitle();
        this.translate(this.$el);
        this.$('.phone-layout-details-container').css('top', this.$('.top').outerHeight());
    },

    /**
     * Populate the header with the info about the current selection
     */
    populateTitle(argument) {
        const feature = this.app.currentFeature;
        this.$('.feature-title').html(feature.getTitle());
        this.$('.feature-desc').html(feature.getShortDescription());
    },

    /**
     * Hides the current view and shows the previous page
     */
    hide() {
        this.$el.hide();
        this.owner.showPage(this.options.prevPageName);
    }
});
export default myw.PhoneLayoutDetails;
